import { useEffect, useState } from 'react';
import { notify } from '../../lib/notifications';

interface Toast {
    id: number;
    message: string;
    type: 'success' | 'error' | 'info';
}

export function ToastContainer() {
    const [toasts, setToasts] = useState<Toast[]>([]);

    useEffect(() => {
        const unsubscribe = notify.subscribe((message, type) => {
            const id = Date.now();
            setToasts(prev => [...prev, { id, message, type }]);

            // Auto dismiss
            setTimeout(() => {
                setToasts(prev => prev.filter(t => t.id !== id));
            }, 3000);
        });

        return unsubscribe;
    }, []);

    if (toasts.length === 0) return null;

    return (
        <div className="fixed top-4 right-4 z-50 space-y-2 pointer-events-none">
            {toasts.map(toast => (
                <div
                    key={toast.id}
                    className={`
                        pointer-events-auto px-4 py-3 rounded-lg shadow-lg text-white text-sm font-medium animate-slide-in
                        ${toast.type === 'success' ? 'bg-success-600' : ''}
                        ${toast.type === 'error' ? 'bg-error-600' : ''}
                        ${toast.type === 'info' ? 'bg-blue-600' : ''}
                    `}
                >
                    <div className="flex items-center gap-2">
                        {toast.type === 'success' && <i className="ri-checkbox-circle-line text-lg"></i>}
                        {toast.type === 'error' && <i className="ri-error-warning-line text-lg"></i>}
                        {toast.type === 'info' && <i className="ri-information-line text-lg"></i>}
                        {toast.message}
                    </div>
                </div>
            ))}
        </div>
    );
}
